export default __webpack_public_path__ + "abeeeb36b559a61e140997713e520837.woff2";